"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: "inherit",
      userSelect: "none"
    },
    header: {
      color: theme.palette.text.secondary,
      fontWeight: "900",
      fontSize: ".75rem",
      padding: theme.spacing(0, 4),
      textTransform: "uppercase"
    },
    subheader: {
      color: theme.palette.text.secondary,
      fontWeight: "400",
      fontSize: ".75rem",
      padding: theme.spacing(0, 4),
      lineHeight: "24px"
    }
  };
};

exports.styles = styles;